import { useCallback, useState } from "react";

export const PAGE_SIZE = 10;

// Pages needed to show the item at `index`, as an item count.
export const limitFor = (index, pageSize = PAGE_SIZE) =>
  Math.ceil((index + 1) / pageSize) * pageSize;

// A list shown a page at a time; "Show more" adds a page. Every item is
// already loaded, so searches still cover all of them. reveal(index) opens
// enough pages to show that item; reset() goes back to the first page (call
// it when the list's own search changes).
export const usePagedList = (items, pageSize = PAGE_SIZE) => {
  const [limit, setLimit] = useState(pageSize);
  const reveal = useCallback(
    (index) => {
      if (index >= 0)
        setLimit((current) => Math.max(current, limitFor(index, pageSize)));
    },
    [pageSize]
  );
  const reset = useCallback(() => setLimit(pageSize), [pageSize]);
  const showMore = useCallback(
    () => setLimit((current) => current + pageSize),
    [pageSize]
  );
  return {
    shown: items.slice(0, limit),
    remaining: Math.max(0, items.length - limit),
    showMore,
    reveal,
    reset,
  };
};
